import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";

// action types
// export const VERIFY_AUTH = "verifyAuth";
export const LOGIN_STEP1 = "loginStep1";
export const LOGIN_STEP2 = "loginStep2";
export const LOGOUT = "logout";
//export const REGISTER = "register";
//export const UPDATE_USER = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
//export const SET_AUTH = "setUser";
export const AUTH_SUCCESS = "authSuccess";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken(),
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
};

const actions = {
  // password login
  [LOGIN_STEP1](context, credentials) {
    context.commit(SET_ERROR, []);
    return ApiService.post("", credentials)
      .then((data) => {
        const result = data && data.returndata;
        if (
          !data ||
          data.returncode !== 1 ||
          !result ||
          typeof result.token !== "string" ||
          result.token.length !== 32
        ) {
          context.commit(SET_ERROR, ["AUTH.LOGIN.INVALID_CREDENTIALS"]);
          return { returncode: 0 };
        }
        if (!result.otprequired) {
          context.commit(AUTH_SUCCESS, result.token);
        }
        return data;
      })
      .catch((error) => {
        context.commit(SET_ERROR, ["COMMON.ERROR"]);
        throw error;
      });
  },
  // two factor auth check
  [LOGIN_STEP2](context, credentials) {
    context.commit(SET_ERROR, []);
    return ApiService.post("", credentials)
      .then((data) => {
        if (
          !data ||
          data.returncode !== 1 ||
          typeof data.returndata !== "string" ||
          data.returndata.length !== 32
        ) {
          context.commit(SET_ERROR, ["AUTH.LOGIN.TFA_INVALID"]);
          return { returncode: 0 };
        }
        context.commit(AUTH_SUCCESS, data.returndata);
        return data;
      })
      .catch((error) => {
        context.commit(SET_ERROR, ["COMMON.ERROR"]);
        throw error;
      });
  },
  [LOGOUT](context, credentials) {
    return new Promise((resolve) => {
      ApiService.post("", credentials)
        .then((data) => {
          context.commit(PURGE_AUTH, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_ERROR, data);
        });
    });
  },
  // [REGISTER](context, credentials) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.post("users", { user: credentials })
  //       .then(data => {
  //         context.commit(SET_AUTH, data);
  //         resolve(data);
  //       })
  //       .catch(data => {
  //         context.commit(SET_ERROR, data);
  //         reject(data);
  //       });
  //   });
  // },
  // [VERIFY_AUTH](context) {
  //   if (JwtService.getToken()) {
  //     return true;
  //     // ApiService.setHeader();
  //     // ApiService.get("verify")
  //     //   .then(({ data }) => {
  //     // context.commit(SET_AUTH, data);
  //     // })
  //     // .catch(({ response }) => {
  //     //   context.commit(SET_ERROR, response.data.errors);
  //     // });
  //   } else {
  //     const data = { returndata: "success" };
  //     context.commit(PURGE_AUTH, data);
  //   }
  // },
  // [UPDATE_USER](context, payload) {
  //   const { email, username, password, image, bio } = payload;
  //   const user = { email, username, bio, image };
  //   if (password) {
  //     user.password = password;
  //   }

  //   return ApiService.put("user", user).then(({ data }) => {
  //     context.commit(SET_AUTH, data);
  //     return data;
  //   });
  // },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors =
      Array.isArray(error) &&
      error.every((message) => typeof message === "string")
        ? error
        : ["COMMON.ERROR"];
  },
  // [SET_AUTH](state, user) {
  //   if (user.returndata) {
  //     state.isAuthenticated = true;
  //     state.user = user;
  //     state.errors = {};
  //     JwtService.saveToken(state.user.returndata);
  //   } else {
  //     // const errorMessage = ""
  //     state.errors = ["Invalid login name and/or password!"];
  //   }
  // },
  [AUTH_SUCCESS](state, token) {
    if (token) {
      state.isAuthenticated = true;
      state.user = token;
      state.errors = {};
      JwtService.saveToken(token);
    } else {
      // const errorMessage = ""
      state.errors = ["Login failed"];
    }
  },
  [PURGE_AUTH](state, data) {
    if (data.returndata == "success") {
      state.isAuthenticated = false;
      state.user = {};
      state.errors = {};
      JwtService.destroyToken();
      let lang = localStorage.language;
      localStorage.clear();
      localStorage.setItem("language", lang);
    }
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
